import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CommonService {


  private url = environment.apiUrl;
  
  constructor(private http: HttpClient) { }
 

  public get(segment: string) {
    return this.http.get(this.url + "/" + segment);
  };

  public post(segment: string, data: any) {
    return this.http.post(this.url + "/" + segment, JSON.stringify(data));
  };

  public update(segment: string, data: any, extr?: any) {
    return this.http.put(this.url + "/" + segment, JSON.stringify(data));
  };

  downloadFile(segment: string, params: object, downloadOptions: any) {
    const { contentType, acceptType, responseType, fileName } = downloadOptions;
    const headerOptions = new HttpHeaders({
      "Content-Type": contentType,
      "Accept": acceptType,
    });
    const requestOptions = {
      headers: headerOptions,
      responseType: responseType,
    };
    this.http
      .post(this.url + "/" + segment, params, requestOptions)
      .pipe(
        map((data: any) => {
          const blob = new Blob([data], {
            type: acceptType,
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        })
      )
      .subscribe();
  }

}
